import { Pipe, PipeTransform } from "@angular/core";
@Pipe({ name: "removeDash" })
export class removeDash implements PipeTransform {
  transform(data: any): any {
    return data ? data.replace(/-/g, " ") : data;
  }
}

@Pipe({ name: "removeUnderScore" })
export class removeUnderScore implements PipeTransform {
  transform(data: any): any {
    return data ? data.replace(/_/g, " ") : data;
  }
}
